<template>
  <div class="schoolCardList-container div-layout">
    <module-title title="名单列表">
      <div class="right">
        <el-button
          type="primary"
          size="medium"
          icon="el-icon-plus"
          @click="handleDialogVisible(2)"
        >
          按SIM卡添加
        </el-button>
        <el-button
          type="primary"
          size="medium"
          icon="el-icon-plus"
          @click="handleDialogVisible(1)"
        >
          按IMEI号添加
        </el-button>
        <el-button
          type="primary"
          size="medium"
          icon="el-icon-upload2"
          @click="handleDialogVisible(3)"
        >
          批量导入
        </el-button>
        <el-button
          type="primary"
          size="medium"
          icon="el-icon-download"
          @click="handleDialogVisible(4)"
        >
          批量导出
        </el-button>
      </div>
    </module-title>

    <div class="schoolCardList-right-contain">
      <el-tabs v-model="activeName" type="border-card" @tab-click="handleTabClick">
        <!-- 按IMEI号 -->
        <el-tab-pane label="按IMEI号" name="first">
          <el-form
            ref="schoolCardSearchForm"
            :model="searchForm"
            :inline="true"
            label-position="right"
          >
            <el-form-item label="绑定状态：" prop="bindStatus">
              <el-select
                v-model="searchForm.bindStatus"
                placeholder="选择状态"
                name="bindStatus"
                size="medium"
                class="edit-form-input"
              >
                <el-option value label="全部" />
                <el-option :value="0" label="未绑定" />
                <el-option :value="1" label="已绑定" />
              </el-select>
            </el-form-item>
            .<el-form-item label="学校：" prop="schoolCode">
              <el-select
                v-model="searchForm.schoolCode"
                placeholder="选择学校"
                name="schoolCode"
                size="medium"
                class="edit-form-input"
                @change="schoolChange"
              >
                <el-option value label="全部" />
                <el-option
                  v-for="item in schoolList"
                  :key="item.schoolCode"
                  :label="item.name"
                  :value="item.schoolCode"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="学生姓名：" prop="studentName">
              <el-input
                v-model="searchForm.studentName"
                name="studentName"
                auto-complete="off"
                size="medium"
                class="edit-form-input"
                placeholder="请输入"
                clearable
              />
            </el-form-item>
            <el-form-item label="IMEI号：" prop="imei">
              <el-input
                v-model="searchForm.imei"
                name="imei"
                auto-complete="off"
                size="medium"
                placeholder="请输入"
                clearable
              />
            </el-form-item>

            <el-form-item style="margin-left:20px;">
              <el-button
                type="primary"
                size="medium"
                icon="el-icon-search"
                @click="fetchSearchFile"
              >
                查询
              </el-button>
            </el-form-item>
          </el-form>
          <el-table
            v-loading="listLoading"
            :data="checkImeiList"
            fit
            element-loading-text="Loading"
            class="list-table"
            highlight-current-row
          >
            <el-table-column label="序号" type="index" align="center" width="55" />
            <el-table-column label="IMEI号" prop="imei" align="center" width="150" />
            <el-table-column label="绑定状态" prop="bindStatusDesc" align="center" />
            <el-table-column label="所在学校" prop="schoolName" align="center" />
            <el-table-column label="年级" prop="gradeName" align="center" />
            <el-table-column label="班级" prop="className" align="center" />
            <el-table-column label="学号" prop="studentNum" align="center" />
            <el-table-column label="绑定学生" prop="name" align="center" />
            <el-table-column label="操作账号" prop="createUserCode" align="center" />
            <el-table-column label="操作时间" prop="createDate" align="center" />
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  type="danger"
                  size="small"
                  icon="el-icon-warning-outline"
                  @click="removeImeiCode(scope.row)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            :total="searchForm.total"
            :page.sync="searchForm.pageNum"
            :limit.sync="searchForm.pageSize"
            @pagination="pageCheckList"
            @handleSizeChange="handleSizeChange"
          />
        </el-tab-pane>
        <!-- 按SIM卡 -->
        <el-tab-pane label="按SIM卡" name="second">
          <el-form
            ref="searchIccidForm"
            :model="searchIccidForm"
            :inline="true"
            label-position="right"
          >
            <el-form-item label="手机号：" prop="mobile">
              <el-input
                v-model="searchIccidForm.mobile"
                name="mobile"
                auto-complete="off"
                size="medium"
                placeholder="请输入"
                clearable
              />
            </el-form-item>
            <el-form-item label="ICCID号：" prop="iccid">
              <el-input
                v-model="searchIccidForm.iccid"
                name="iccid"
                auto-complete="off"
                size="medium"
                placeholder="请输入"
                clearable
              />
            </el-form-item>
            <el-form-item label="SIM卡类型：" prop="cardType">
              <el-select v-model="searchIccidForm.cardType" placeholder="请选择" class="edit-form-input">
                <el-option label="全部" value="" />
                <el-option label="新开卡" :value="1" />
                <el-option label="叠加包" :value="2" />
              </el-select>
            </el-form-item>
            <el-form-item label="叠加包状态：" prop="packageStatus">
              <el-select v-model="searchIccidForm.packageStatus" placeholder="请选择" class="edit-form-input">
                <el-option label="全部" value="" />
                <el-option label="未生效" :value="0" />
                <el-option label="正常" :value="1" />
                <el-option label="已到期" :value="2" />
              </el-select>
            </el-form-item>

            <el-form-item style="margin-left:50px;">
              <el-button
                type="primary"
                size="medium"
                icon="el-icon-search"
                @click="fetchSearchIccid"
              >
                查询
              </el-button>
              <el-button
                type="primary"
                size="medium"
                icon="el-icon-edit"
                @click="handleDialogVisible(5)"
              >
                批量修改
              </el-button>
            </el-form-item>
          </el-form>
          <el-table
            v-loading="listLoading"
            :data="checkIccidList"
            fit
            element-loading-text="Loading"
            class="list-table"
            highlight-current-row
          >
            <el-table-column label="序号" type="index" align="center" width="55" />
            <el-table-column label="手机号" prop="mobile" align="center" />
            <el-table-column label="ICCID" prop="iccid" align="center">
              <template slot-scope="scope">
                {{ scope.row.iccid?scope.row.iccid:'---' }}
              </template>
            </el-table-column>
            <el-table-column label="SIM卡类型" prop="cardType" align="center">
              <template slot-scope="scope">
                <!-- 1-新开卡 2-叠加包 -->
                {{ scope.row.cardType===1?"新开卡":'叠加包' }}
              </template>
            </el-table-column>
            <el-table-column label="叠加包生效日期" prop="activeDate" align="center">
              <template slot-scope="scope">
                {{ scope.row.activeDate?scope.row.activeDate:'---' }}
              </template>
            </el-table-column>
            <el-table-column label="叠加包状态" prop="packageStatus" align="center">
              <template slot-scope="scope">
                <!-- 0-未生效 1-正常 2-已到期 -->
                {{ scope.row.packageStatus===2?"已到期":scope.row.packageStatus?'正常':scope.row.packageStatus===0?'未生效':'---' }}
              </template>
            </el-table-column>
            <el-table-column label="操作账号" prop="createUserCode" align="center" />
            <el-table-column label="操作时间" prop="updateDate" align="center" />
            <el-table-column label="操作" align="center" width="250px">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.cardType===2&&(scope.row.packageStatus===2||scope.row.packageStatus===1)"
                  type="primary"
                  size="small"
                  icon="el-icon-edit"
                  @click="editSIMCode(scope.row)"
                >
                  编辑
                </el-button>
                <el-button
                  type="danger"
                  size="small"
                  icon="el-icon-warning-outline"
                  @click="removeSIMCode(scope.row)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            :total="searchIccidForm.total"
            :page.sync="searchIccidForm.pageNum"
            :limit.sync="searchIccidForm.pageSize"
            @pagination="pageCheckSIMList"
            @handleSizeChange="handleSizeSIMChange"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 编辑叠加包状态-->
    <el-dialog
      v-if="dialogViewIMEIEditVisible"
      :close-on-click-modal="false"
      :visible.sync="dialogViewIMEIEditVisible"
      title="编辑叠加包状态"
      width="540px"
      :destroy-on-close="true"
    >
      <el-form
        ref="simEditSubmit"
        :rules="simEditSubmitRules"
        :model="simEditSubmit"
        label-position="right"
        label-width="120px"
      >
        <el-form-item label="手机号：" prop="mobile">
          <span>{{ simEditSubmit.mobile }}</span>
        </el-form-item>
        <el-form-item label="叠加包状态：" prop="packageStatus">
          <el-select
            v-model="simEditSubmit.packageStatus"
            name="packageStatus"
            size="medium"
          >
            <el-option :value="1" label="正常" />
            <el-option :value="2" label="已到期" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="dialogViewIMEIEditVisible = false">
          取消
        </el-button>
        <el-button type="primary" size="medium" @click="handlerSIMEditSubmit">
          确定
        </el-button>
      </div>
    </el-dialog>
    <!-- 按SIM卡添加 -->
    <el-dialog
      v-if="dialogViewSIMVisible"
      :close-on-click-modal="false"
      :visible.sync="dialogViewSIMVisible"
      title="按SIM卡添加"
      width="540px"
    >
      <el-form
        ref="simAddSubmit"
        v-loading="simAddLoading"
        :rules="simAddSubmitRules"
        :model="simAddSubmit"
        label-position="right"
        label-width="120px"
      >
        <el-form-item label="手机号：" prop="mobile">
          <el-input
            v-model="simAddSubmit.mobile"
            name="mobile"
            auto-complete="off"
            maxlength="11"
            size="medium"
            placeholder="请输入"
            clearable
          />
        </el-form-item>
        <el-form-item label="ICCID号：" prop="iccid">
          <el-input
            v-model="simAddSubmit.iccid"
            name="iccid"
            auto-complete="off"
            maxlength="20"
            size="medium"
            placeholder="请输入"
            clearable
          />
        </el-form-item>
        <el-form-item label="SIM卡类型：" prop="cardType">
          <el-select
            v-model="simAddSubmit.cardType"
            placeholder="选择状态"
            name="cardType"
            size="medium"
            class="edit-form-input"
          >
            <el-option :value="2" label="叠加包" />
            <el-option :value="1" label="新开卡" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="simAddSubmit.cardType===2" label="生效日期：" prop="activeDate">
          <el-date-picker
            v-model="simAddSubmit.activeDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择生效日期"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="dialogViewSIMVisible = false">
          取消
        </el-button>
        <el-button type="primary" size="medium" @click="handlerSIMAddSubmit">
          确定
        </el-button>
      </div>
    </el-dialog>
    <!-- 按IMEI号添加 -->
    <el-dialog
      v-if="dialogViewIMEIVisible"
      :close-on-click-modal="false"
      :visible.sync="dialogViewIMEIVisible"
      title="按IMEI号添加"
      width="540px"
    >
      <el-form
        ref="iemiAddSubmit"
        v-loading="iemiAddLoading"
        :rules="iemiAddSubmitRules"
        :model="iemiAddSubmit"
        label-position="right"
        label-width="120px"
      >
        <el-form-item label="IMEI号：" prop="imei">
          <el-input
            v-model="iemiAddSubmit.imei"
            name="imei"
            maxlength="15"
            auto-complete="off"
            size="medium"
            placeholder="请输入"
            clearable
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="dialogViewIMEIVisible = false">
          取消
        </el-button>
        <el-button type="primary" size="medium" @click="handlerIMEIAddSubmit">
          确定
        </el-button>
      </div>
    </el-dialog>
    <!-- 批量修改叠加包状态 -->
    <el-dialog
      v-if="dialogUploadVisiblePackage"
      :close-on-click-modal="false"
      :visible.sync="dialogUploadVisiblePackage"
      title="批量修改叠加包状态"
      width="540px"
    >
      <el-form
        ref="uploadSubmitPackage"
        v-loading="simPackageLoading"
        :model="uploadSubmitPackage"
        label-position="right"
        label-width="120px"
      >
        <div class="textCenter">
          <el-button type="primary" style=" margin-bottom: 20px" icon="el-icon-upload2" size="medium" @click="handlerExcelTemplate($event,3)">
            下载模板
          </el-button>
          <el-upload
            ref="upload"
            :on-success="onSuccessPackage"
            :action="uploadUrl"
            :headers="uploadHeader"
            :on-progress="onProgress"
            :on-error="onError"
            :multiple="false"
            :limit="1"
            name="file"
            accept=".xls, .xlsx"
            class="handle-btn"
          >
            <el-button
              :loading="fileUploading"
              size="medium"
              type="primary"
              icon="el-icon-upload2"
            >
              {{ fileUploading?'上传文件中...':'上传文件' }}
            </el-button>
          </el-upload>
        </div>
      </el-form>
    </el-dialog>
    <!-- 批量导入 -->
    <el-dialog
      v-if="dialogUploadVisible"
      :close-on-click-modal="false"
      :visible.sync="dialogUploadVisible"
      title="批量导入"
      width="540px"
    >
      <el-form
        ref="uploadSubmit"
        v-loading="simAddLoading"
        :model="uploadSubmit"
        label-position="right"
        label-width="120px"
      >
        <el-form-item label="选择类型：" prop="simType">
          <el-select
            v-model="uploadSubmit.simType"
            placeholder="选择类型"
            name="simType"
            size="medium"
            @change="handlerUpload"
          >
            <el-option :value="1" label="按IMEI号" />
            <el-option :value="2" label="按SIM卡" />
          </el-select>
        </el-form-item>
        <div class="textCenter">
          <el-button type="primary" style=" margin-bottom: 20px" icon="el-icon-upload2" size="medium" @click="handlerExcelTemplate">
            下载模板
          </el-button>
          <el-upload
            ref="upload"
            :on-success="onSuccess"
            :action="uploadUrl"
            :headers="uploadHeader"
            :on-progress="onProgress"
            :on-error="onError"
            :multiple="false"
            :limit="1"
            name="file"
            accept=".xls, .xlsx"
            class="handle-btn"
            :data="uploadSubmitData"
          >
            <el-button
              :loading="fileUploading"
              size="medium"
              type="primary"
              icon="el-icon-upload2"
            >
              {{ fileUploading?'上传文件中...':'上传文件' }}
            </el-button>
          </el-upload>
        </div>
      </el-form>
    </el-dialog>
    <!-- 异常数据 -->
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogMultipleImportVisible"
      title="异常数据"
    >
      <p style="padding:0 0 20px 20px;">
        导入失败，存在{{ abnormalDataList.length }}条异常记录，请修改后重新上传
      </p>
      <el-scrollbar wrap-class="abnormal-table">
        <el-table
          :data="abnormalDataList"
          fit
          highlight-current-row
        >
          <el-table-column type="index" width="55" align="center" label="序号" />
          <el-table-column label="异常原因" prop="errorMsg" align="center">
            <template slot-scope="scope">
              <span class="red">{{ scope.row.errorMsg }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="uploadSubmit.simType===1" label="imei" prop="imei" align="center" />
          <el-table-column v-if="uploadSubmit.simType===2" label="手机号" prop="mobile" align="center" />
          <el-table-column v-if="uploadSubmit.simType===2" label="ICCID号" prop="iccid" align="center" />
          <el-table-column v-if="uploadSubmit.simType===2" label="SIM卡类型" prop="cardType" align="center" />
          <el-table-column v-if="uploadSubmit.simType===2" label="叠加包生效日期" prop="activeDate" align="center" />
        </el-table>
      </el-scrollbar>
    </el-dialog>
    <!-- 批量导出 -->
    <el-dialog
      v-if="dialogDownloadVisible"
      :close-on-click-modal="false"
      :visible.sync="dialogDownloadVisible"
      title="批量导出"
      width="540px"
    >
      <el-form
        ref="downCheckSubmit"
        v-loading="simAddLoading"
        :model="downCheckSubmit"
        label-position="right"
        label-width="120px"
      >
        <el-form-item label="选择类型：" prop="simType">
          <el-select
            v-model="downCheckSubmit.simType"
            placeholder="选择类型"
            name="simType"
            size="medium"
            class="edit-form-input"
          >
            <el-option :value="1" label="按IMEI号" />
            <el-option :value="2" label="按SIM卡" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="dialogDownloadVisible = false">
          取消
        </el-button>
        <el-button type="primary" size="medium" @click="handlerDownCheck">
          确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getToken } from '@/utils/auth';

import {
  getIllegalCheckImeiList,
  getIllegalCheckIccidList,
  getIllegalCheckIccidAdd,
  getIllegalCheckImeiAdd,
  getIllegalCheckImeiDel,
  getIllegalCheckIccidDel,
  getSchoolList,
  illegalCheckExcelTemplate,
  exportSimExcel,
  exportImeiExcel,
  improtExcelSIM,
  improtExcelIMEI,
  getUpdateSimStatus,
  improtExcelStatus,
  batchUpDateTemplate
} from '@/api/systemMaintenance/devicManage/illegalCheck';
import { mapGetters } from 'vuex';
export default {
  name: 'CheckList',
  data() {
    var validateMobile = (rule, value, callback) => {
      const pattern = new RegExp(/^1\d{10}$/);
      if (!value) {
        callback(new Error('手机号不能为空'));
      } else if (value !== '' && value !== null) {
        if (!(pattern.test(value))) {
          callback(new Error('请输入正确的手机号'));
          return false;
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    // var validateIccid = (rule, value, callback) => {
    //   const pattern1 = new RegExp(/^([0-9]|[a-z]|[A-Z]){20}$/);
    //   if (value !== '' && value !== null) {
    //     if (!(pattern1.test(value))) {
    //       callback(new Error('请输入正确的ICCID号'));
    //       return false;
    //     } else {
    //       callback();
    //     }
    //   } else {
    //     callback();
    //   }
    // };
    var validateIemi = (rule, value, callback) => {
      const pattern2 = new RegExp(/^\d{15}$/);

      if (value !== '' && value !== null) {
        if (!(pattern2.test(value))) {
          callback(new Error('请输入正确IMEI号'));
          return false;
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      activeName: 'first', // 当前显示tab 默认first
      simAddLoading: false,
      iemiAddLoading: false,
      dialogUploadVisible: false, // 批量导入
      dialogDownloadVisible: false, //  批量导出
      dialogViewSIMVisible: false, // 按SIM卡添加
      dialogViewIMEIVisible: false, // 按IMEI号添加
      dialogViewIMEIEditVisible: false,
      dialogMultipleImportVisible: false, // 异常数据
      dialogUploadVisiblePackage: false, // 异常数据
      simPackageLoading: false,
      uploadSubmitPackage: {

      },
      searchForm: {
        imei: '',
        schoolCode: '',
        studentCodeList: '',
        studentName: '',
        bindStatus: '',

        pageNum: 1,
        pageSize: 10,
        total: 0,
        exprotType: 1
      }, // 按IMEI搜索参数
      searchIccidForm: {
        iccid: '',
        mobile: '',
        packageStatus: '',
        cardType: '',
        pageNum: 1,
        pageSize: 10,
        total: 0
      }, // 按SIM卡搜索参数
      simAddSubmit: {
        mobile: '',
        iccid: '',
        cardType: '',
        activeDate: ''
      }, // 按SIM卡添加
      simEditSubmit: {
        mobile: '',
        packageStatus: ''
      }, // 按SIM卡编辑
      simAddSubmitRules: {
        mobile: [
          { required: true, trigger: 'blur', validator: validateMobile }
        ],
        cardType: [
          { required: true, trigger: 'change', message: 'SIM卡类型不能为空' }
        ],
        activeDate: [
          { required: true, trigger: 'change', message: '生效日期不能为空' }
        ]
      },
      simEditSubmitRules: {
        mobile: [
          { trigger: 'blur', validator: validateMobile }
        ],
        packageStatus: [
          { required: true, trigger: 'blur', message: '叠加包状态不能为空' }
        ]
      },
      iemiAddSubmit: {
        imei: ''
      }, // 按IMEI号添加
      iemiAddSubmitRules: {
        imei: [
          { required: true, trigger: 'blur', message: 'IMEI不能为空' },
          { trigger: 'blur', validator: validateIemi }
        ]
      },
      uploadSubmit: {
        simType: 1
      }, // 批量导入
      uploadSubmitData: {
        userCode: ''
      }, // 批量导入上传文件参数

      downCheckSubmit: {
        simType: 1
      }, // 批量导出
      fileUploading: false, // 文件上传加载
      uploadUrl: '', // 上传文件URL
      uploadHeader: {
      }, // 上传文件上传头
      abnormalDataList: [], // 异常数据列表
      listLoading: false, // 表格刷新loading
      checkImeiList: [], //  imei列表
      checkIccidList: [], //  Iccid列表
      schoolList: [] //  学校列表
    };
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  mounted() {
    this.fetchSchoolList();
    this.initUploadData();
  },
  methods: {
    // 初始化上传数据
    initUploadData() {
      const accessToken = getToken();
      this.uploadHeader = {
        Authorization: `Bearer ${accessToken}`
      };
      this.uploadSubmitData.userCode = this.userInfo.code ? this.userInfo.code : '';
    },
    // Tab切换
    handleTabClick(tab, event) {
      if (this.activeName === 'second') {
        this.searchIccidForm = {
          iccid: '',
          mobile: '',
          packageStatus: '',
          cardType: '',
          pageNum: 1,
          pageSize: 10,
          total: 0
        };
        this.fetchCheckIccidList();
      } else {
        this.searchForm = {
          imei: '',
          schoolCode: '',
          studentCodeList: '',
          studentName: '',
          bindStatus: '',

          pageNum: 1,
          pageSize: 10,
          total: 0,
          exprotType: 1
        };
        this.fetchCheckImeiList();
      }
    },
    // 分页imei
    pageCheckList(obj) {
      this.searchForm.pageNum = obj.page;
      this.fetchCheckImeiList();
    },

    // 分页条数变化imei
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.fetchCheckImeiList();
    },

    fetchSearchFile() {
      this.searchForm.pageNum = 1;
      this.fetchCheckImeiList();
    },
    // 分页iccid列表
    pageCheckSIMList(obj) {
      this.searchIccidForm.pageNum = obj.page;
      this.fetchCheckIccidList();
    },

    // 分页条数变化iccid列表
    handleSizeSIMChange(obj) {
      this.searchIccidForm.pageSize = obj.limit;
    },
    fetchSearchIccid() {
      this.searchIccidForm.pageNum = 1;
      this.fetchCheckIccidList();
    },
    // 下载模板
    handlerExcelTemplate(ev, val) {
      if (val) {
        window.location.href = batchUpDateTemplate();
      } else {
        window.location.href = illegalCheckExcelTemplate(this.uploadSubmit.simType);
      }
    },
    // 按IMEI号 1、SIM卡 2添加 弹框显示
    handleDialogVisible(val) {
      if (val === 1) {
        this.iemiAddSubmit = {
          iemi: ''
        };
        this.dialogViewIMEIVisible = true;
      } else if (val === 2) {
        this.simAddSubmit = {
          mobile: '',
          iccid: '',
          cardType: '',
          activeDate: ''
        };
        this.dialogViewSIMVisible = true;
      } else if (val === 3) {
        this.uploadSubmit = {
          simType: ''
        };
        this.dialogUploadVisible = true;
        this.handlerUpload(1);
      } else if (val === 5) {
        this.dialogUploadVisiblePackage = true;
        this.handlerUpload(3);
      } else {
        this.downCheckSubmit = {
          simType: 1
        };
        this.dialogDownloadVisible = true;
      }
    },
    // 批量导入 simType 1是IMEI卡 2是SIM卡
    handlerUpload(val) {
      this.uploadUrl = '';
      this.uploadSubmit.simType = val;
      if (this.uploadSubmit.simType === 1) {
        this.uploadSubmitData.importType = 1;
        this.uploadUrl = improtExcelIMEI();
      } else if (this.uploadSubmit.simType === 2) {
        delete this.uploadSubmitData.importType;
        this.uploadUrl = improtExcelSIM();
      } else {
        this.uploadUrl = improtExcelStatus();
      }
    },

    // 导入 加载
    onProgress() {
      this.fileUploading = true;
    },

    // 导入上传成功
    onSuccess(response, file, fileList) {
      this.fileUploading = false;
      this.$refs.upload.clearFiles();
      if (response.code === '0') {
        this.$message({
          message: '文件上传成功',
          type: 'success'
        });
        this.handleTabClick();
        this.dialogUploadVisible = false;
      } else {
        if (response.data) {
          this.dialogMultipleImportVisible = true;
          this.abnormalDataList = response.data;
        } else {
          this.$message({
            message: response.message,
            type: 'error'
          });
          this.abnormalDataList = [];
        }
      }
    },

    // 导入上传成功
    onSuccessPackage(response, file, fileList) {
      this.fileUploading = false;
      this.$refs.upload.clearFiles();
      if (response.code === '0') {
        this.$message({
          message: '文件上传成功',
          type: 'success'
        });
        this.handleTabClick();
        this.dialogUploadVisiblePackage = false;
      } else {
        if (response.data) {
          this.dialogMultipleImportVisible = true;
          this.abnormalDataList = response.data;
        } else {
          this.$message({
            message: response.message,
            type: 'error'
          });
          this.abnormalDataList = [];
        }
      }
    },

    // 导入上传失败
    onError() {
      this.fileUploading = false;
      this.$refs.upload.clearFiles();
      this.$message({
        message: '选择类型与上传文件模板不匹配',
        type: 'error'
      });
    },

    // 批量导出
    handlerDownCheck() {
      this.dialogDownloadVisible = false;
      if (this.downCheckSubmit.simType === 1) {
        window.location.href = exportImeiExcel(this.searchForm);
      } else {
        window.location.href = exportSimExcel(this.searchIccidForm);
      }
    },
    handlerSIMEditSubmit() {
      this.$refs['simEditSubmit'].validate(valid => {
        if (valid) {
          var options = {
            mobile: this.simEditSubmit.mobile,
            packageStatus: this.simEditSubmit.packageStatus

          };
          getUpdateSimStatus(options)
            .then(res => {
              this.$notify.success({
                title: 'Success',
                message: '编辑成功',
                showClose: false,
                duration: 2000
              });
              this.dialogViewIMEIEditVisible = false;
              this.activeName = 'second';
              this.fetchCheckIccidList();
            })
            .catch(() => {
              this.simAddLoading = false;
            });
        }
      });
    },
    // 按SIM卡添加内容
    handlerSIMAddSubmit() {
      this.$refs['simAddSubmit'].validate(valid => {
        if (valid) {
          this.simAddLoading = true;
          var options = {
            mobile: this.simAddSubmit.mobile,
            iccid: this.simAddSubmit.iccid,
            cardType: this.simAddSubmit.cardType,
            activeDate: this.simAddSubmit.activeDate ? this.simAddSubmit.activeDate : null,
            createUserCode: this.userInfo.code ? this.userInfo.code : ''

          };
          getIllegalCheckIccidAdd(options)
            .then(res => {
              this.$notify.success({
                title: 'Success',
                message: '添加成功',
                showClose: false,
                duration: 2000
              });
              this.simAddLoading = false;
              this.dialogViewSIMVisible = false;
              this.activeName = 'second';
              this.fetchCheckIccidList();
            })
            .catch(() => {
              this.simAddLoading = false;
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 按IMEI号添加内容
    handlerIMEIAddSubmit() {
      this.$refs['iemiAddSubmit'].validate(valid => {
        if (valid) {
          this.iemiAddLoading = true;
          var options = {
            imei: this.iemiAddSubmit.imei,
            createUserCode: this.userInfo.code ? this.userInfo.code : ''

          };
          getIllegalCheckImeiAdd(options)
            .then(res => {
              this.$notify.success({
                title: 'Success',
                message: '添加成功',
                showClose: false,
                duration: 2000
              });
              this.iemiAddLoading = false;
              this.activeName = 'first';
              this.fetchCheckImeiList();
              this.dialogViewIMEIVisible = false;
            })
            .catch(() => {
              this.iemiAddLoading = false;
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 删除imei
    removeImeiCode(row) {
      var whileListId = [row.id];
      this.$confirm(`确定要删除么?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => getIllegalCheckImeiDel(whileListId))
        .then(res => {
          this.$notify.success({
            title: 'Success',
            message: '删除成功',
            showClose: false,
            duration: 2000
          });
          this.fetchCheckImeiList();
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 编辑SIM
    editSIMCode(row) {
      this.dialogViewIMEIEditVisible = true;
      this.simEditSubmit.mobile = row.mobile;
      this.simEditSubmit.packageStatus = row.packageStatus;
    },
    // 删除SIM
    removeSIMCode(row) {
      var mobileIdList = [row.mobileId];
      this.$confirm(`确定要删除么?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => getIllegalCheckIccidDel(mobileIdList))
        .then(res => {
          this.$notify.success({
            title: 'Success',
            message: '删除成功',
            showClose: false,
            duration: 2000
          });
          this.fetchCheckIccidList();
        })
        .catch(err => {
          console.log(err);
        });
    },

    // 获取imei列表名单
    fetchCheckImeiList() {
      var option = {
        ...this.searchForm
      };
      delete option.exprotType;
      delete option.total;
      getIllegalCheckImeiList(option).then(res => {
        if (res.data && res.data.list && res.data.list.length > 0) {
          this.checkImeiList = res.data.list;
          this.searchForm.total = res.data.total;
        } else {
          this.checkImeiList = [];
        }
      });
    },
    // 获取iccid列表
    fetchCheckIccidList() {
      var option = {
        ...this.searchIccidForm
      };
      delete option.total;
      getIllegalCheckIccidList(option).then(res => {
        if (res.data && res.data.list && res.data.list.length > 0) {
          this.checkIccidList = res.data.list;
          this.searchIccidForm.total = res.data.total;
        } else {
          this.checkIccidList = [];
        }
      });
    },

    // 获取学校列表
    fetchSchoolList() {
      getSchoolList(this.searchForm.schoolCode).then(res => {
        if (res.data) {
          this.schoolList = res.data
            ? res.data
            : [];
        }
        this.fetchCheckImeiList();
      });
    },
    // 学校选择
    schoolChange(val) {
      this.searchForm.schoolCode = val;
    }
  }
};
</script>
<style lang="scss" scoped>
.text-center{ text-align: center; }
.schoolCardList-container {
    .edit-form-input {
      width: 6.8vw;
    }
    .textCenter{text-align: center;padding: 20px;
    .el-button {
      width: 160px;
    }

  }

  // .handle-form-input{ width: 160px;}
  // 查看详情
  .archivesTitle {
    color: #1890ff;
    font-size: 14px;
    font-weight: bold;
    padding-left: 30px;
    padding-bottom: 20px;
  }
  .red{color: red;}
  .manager-info {
    ul {
      margin-left: 60px;
      width: 50%;
      min-width: 220px;
      li {
        margin-bottom: 20px;
      }
    }
  }
}
</style>
